import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './open-app-store.component.scss';
var OpenAppStore = /** @class */ (function (_super) {
    tslib_1.__extends(OpenAppStore, _super);
    function OpenAppStore(element) {
        return _super.call(this, element) || this;
    }
    OpenAppStore.prototype.init = function () {
        this.button = this.element.querySelector('.open-app-store__button--link');
        this.buttonClose = this.element.querySelector('.open-app-store__close');
        this.attributeIos = this.element.getAttribute('data-link-ios');
        this.attributeAndroid = this.element.getAttribute('data-link-android');
        this.attributeDescriptionIos = this.element.getAttribute('data-description-ios');
        this.attributeDescriptionAndroid = this.element.getAttribute('data-description-android');
        this.containerDescription = this.element.querySelector('.open-app-store__content--description');
        this.detectBrowser();
    };
    OpenAppStore.prototype.bindEvents = function () {
        // $(document).on('click', 'open-app-store__smart-banner .close', function (event) {
        var _this = this;
        // 	event.preventDefault();
        // 	  var $banner = $('open-app-store__smart-banner');
        // 	$banner.css('margin-top',0 - $banner.outerHeight());
        //   });
        this.buttonClose.addEventListener('click', function (event) {
            if (_this.element.classList.contains('hide')) {
                _this.element.classList.remove('hide');
            }
            else {
                _this.element.classList.add('hide');
            }
        });
    };
    OpenAppStore.prototype.isIOSDevice = function () {
        return !!navigator.platform && /iPad|iPhone|iPod|AppleWebKit/.test(navigator.platform);
    };
    OpenAppStore.prototype.detectBrowser = function () {
        if (this.isIOSDevice()) {
            this.button.setAttribute('href', this.attributeIos);
            this.containerDescription.innerHTML = this.attributeDescriptionIos;
        }
        else {
            this.button.setAttribute('href', this.attributeAndroid);
            this.containerDescription.innerHTML = this.attributeDescriptionAndroid;
        }
    };
    return OpenAppStore;
}(Base));
export { OpenAppStore };



//////////////////
// WEBPACK FOOTER
// ./components/open-app-store/open-app-store.component.ts
// module id = 420
// module chunks = 0